/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Recurrence_Interval_NullInputs */

const en_enum_recurrence_interval_null = /** @type {(inputs: Enum_Recurrence_Interval_NullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Null`)
};

const de_enum_recurrence_interval_null = /** @type {(inputs: Enum_Recurrence_Interval_NullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Null`)
};

/**
* | output |
* | --- |
* | "Null" |
*
* @param {Enum_Recurrence_Interval_NullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_recurrence_interval_null = /** @type {((inputs?: Enum_Recurrence_Interval_NullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Recurrence_Interval_NullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_recurrence_interval_null(inputs)
	return de_enum_recurrence_interval_null(inputs)
});